/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button, CircularProgress, Tooltip } from '@material-ui/core';
import examType1Actions from '../../../../../../../redux/actions/examType1Actions';

const useStyles = makeStyles(() => ({
  button: {
    marginTop: '2em',
  },
  buttonWrapper: {
    position: 'relative',
    marginTop: '2em',
  },
  spinner: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const SAVE_STATUS = {
  IDLE: 'idle',
  PENDING: 'pending',
  SAVED: 'saved',
  ERROR: 'error',
};

const NextButton = ({
  pushAnswer, currentAnswer, setCurrentQuestion, saveStatus,
}) => {
  const classes = useStyles();
  const currentQuestion = localStorage.getItem('currentQuestion') !== null ? parseInt(localStorage.getItem('currentQuestion'), 10) : 0;

  const handleNext = () => {
    pushAnswer();
    setCurrentQuestion(currentQuestion + 1);
  };

  const noAnswer = currentAnswer && currentAnswer.length === 0;
  const isSaving = saveStatus === SAVE_STATUS.PENDING;
  // En cas d'erreur définitive, on laisse quand même passer pour ne pas bloquer l'étudiant :
  // les réponses sont dans le localStorage et seront renvoyées au sendTest final.
  const isDisabled = noAnswer || isSaving;

  const tooltipTitle = isSaving
    ? 'Sauvegarde de votre réponse précédente en cours…'
    : '';

  return (
    <Tooltip title={tooltipTitle} disableHoverListener={!isSaving}>
      <div className={classes.buttonWrapper}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleNext}
          disabled={isDisabled}
          fullWidth
          style={{ fontSize: 19, lineHeight: 1.5 }}
        >
          {isSaving ? 'Sauvegarde…' : 'Submit'}
        </Button>
        {isSaving && <CircularProgress size={24} className={classes.spinner} />}
      </div>
    </Tooltip>
  );
};

NextButton.defaultProps = {
  saveStatus: SAVE_STATUS.IDLE,
};

NextButton.propTypes = {
  currentAnswer: PropTypes.array.isRequired,
  setCurrentQuestion: PropTypes.func.isRequired,
  pushAnswer: PropTypes.func.isRequired,
  saveStatus: PropTypes.string,
};

const actionCreators = {
  setCurrentQuestion: examType1Actions.setCurrentQuestion,
  pushAnswer: examType1Actions.pushAnswer,
};

function mapState(state) {
  const { currentAnswer } = state.exam;
  return {
    currentAnswer,
  };
}
export default connect(mapState, actionCreators)(NextButton);
